var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-display-options"},_vm._l((_vm.options),function(option,index){return _c('span',{key:index,class:[
      'v-display-options__option',
      option === _vm.selectedOption && 'v-display-options__option--selected'
    ],on:{"click":function($event){return _vm.onClick(option)}}},[_c('icon',{attrs:{"name":option}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }